import {ApiV0} from "../../api.v0";
import {RestApiService} from "../../../rest-api.service";

export class ApiV0Manage {
  segment = '/manage';

  // @ts-ignore
    constructor(v0: ApiV0, private rest: RestApiService) {
    this.segment = v0.segment + this.segment;
  }
}
